import axiosInstance from "auth/FetchInterceptor";
import { NHAPKHO_API } from "constants/ApiConstant";
const NhapKhoService = {};

NhapKhoService.getNhapKhoCTByManx = function (data) {
  return axiosInstance.post(`${NHAPKHO_API}/get-ct-by-manx`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};

NhapKhoService.addNhapKhoCT = function (data) {
  return axiosInstance.post(`${NHAPKHO_API}/add-nhapkhoct`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapKhoService.updateNhapKhoCT = function (data) {
  return axiosInstance.post(`${NHAPKHO_API}/update-nhapkhoct`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapKhoService.deleteNhapKhoCT = function (id) {
  return axiosInstance.delete(`${NHAPKHO_API}/delete-nhapkhoct?manxct=${id}`, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapKhoService.getHangHoaNhapKho = function (data) {
  return axiosInstance.post(`${NHAPKHO_API}/get-hang-hoa-nhap-kho`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapKhoService.getHangHoaThayThe = function (data) {
  return axiosInstance.post(`${NHAPKHO_API}/get-hang-hoa-thay-the`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
NhapKhoService.getListDonViXuatHDDT = function () {
  return axiosInstance.get(`${NHAPKHO_API}/get-list-donvi-xuat-hddt`, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};

NhapKhoService.SendMisa = function (data) {
  return axiosInstance.post(`${NHAPKHO_API}/send-misa`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};

NhapKhoService.GetMauHDDT = function (data) {
  return axiosInstance.post(`${NHAPKHO_API}/lay-mau-hoa-don-misa`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};

NhapKhoService.PhatHanhHDDTMisa = function (data) {
  return axiosInstance.post(`${NHAPKHO_API}/phat-hanh-hoa-don-misa`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};

// TODO (backend): API mới - gộp nhiều phiếu bán buôn (ids) để phát hành CHUNG 1 hóa đơn Misa.
// Payload đề xuất: { ids: string[] (idphieu của các phiếu được chọn), idInvSeries, invSeries }
NhapKhoService.PhatHanhHDDTMisaGop = function (data) {
  return axiosInstance.post(`${NHAPKHO_API}/phat-hanh-hoa-don-misa-gop`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
// TODO (backend): Luồng thay thế / điều chỉnh HĐ Misa bằng cách sửa trên phiếu gốc.
// Mọi API xử lý theo "mahoadon" (lấy toàn bộ phiếu thuộc HĐ trong DB).
// B1 - Mở điều chỉnh: { mahoadon, loai: 1 (thay thế) | 2 (điều chỉnh), lydo }
//   -> snapshot phiếu + chi tiết, gắn cờ dangdieuchinh (giữ nguyên daduyet),
//      cho phép sửa phiếu đã duyệt khi đang có cờ.
NhapKhoService.MoDieuChinhHDDTMisa = function (data) {
  return axiosInstance.post(
    `${NHAPKHO_API}/mo-dieu-chinh-hoa-don-misa`,
    data,
    {
      baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
    }
  );
};
// Danh sách phiếu: { mahoadon } -> [{ mabanhang, sophieu, ngay, tongtien,
//   thaotac: 0 giữ trong HĐ | 1 thêm vào | 2 bỏ ra | null có thể thêm }]
NhapKhoService.DsPhieuDieuChinhHDDTMisa = function (data) {
  return axiosInstance.post(
    `${NHAPKHO_API}/ds-phieu-dieu-chinh-hoa-don-misa`,
    data,
    {
      baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
    }
  );
};
// Thêm / bớt phiếu: { mahoadon, ids: mabanhang[] (toàn bộ phiếu muốn có trong HĐ mới) }
NhapKhoService.CapNhatPhieuDieuChinhHDDTMisa = function (data) {
  return axiosInstance.post(
    `${NHAPKHO_API}/cap-nhat-phieu-dieu-chinh-hoa-don-misa`,
    data,
    {
      baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
    }
  );
};
// B2 - Xem trước: { mahoadon } -> { loai, lydo, phieu: [...], dong: [{ tenhh, dvt,
//   soluongGoc, dongiaGoc, thanhtienGoc, soluongMoi, dongiaMoi, thanhtienMoi, chenhlech }] }
NhapKhoService.XemTruocDieuChinhHDDTMisa = function (data) {
  return axiosInstance.post(
    `${NHAPKHO_API}/xem-truoc-dieu-chinh-hoa-don-misa`,
    data,
    {
      baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
    }
  );
};
// B3 - Phát hành: { mahoadon, idInvSeries, invSeries } -> thay thế gửi toàn bộ,
//   điều chỉnh gửi chênh lệch so với snapshot; cập nhật HĐ mới, xóa cờ + snapshot.
NhapKhoService.ThayTheDieuChinhHDDTMisa = function (data) {
  return axiosInstance.post(
    `${NHAPKHO_API}/thay-the-dieu-chinh-hoa-don-misa`,
    data,
    {
      baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
    }
  );
};
// Hủy điều chỉnh: { mahoadon } -> khôi phục phiếu + chi tiết từ snapshot, xóa cờ.
NhapKhoService.HuyDieuChinhHDDTMisa = function (data) {
  return axiosInstance.post(
    `${NHAPKHO_API}/huy-dieu-chinh-hoa-don-misa`,
    data,
    {
      baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
    }
  );
};
NhapKhoService.InHDDTMisa = function (data) {
  return axiosInstance.post(`${NHAPKHO_API}/in-hoa-don-misa`, data, {
    baseURL: process.env.REACT_APP_PHARMA_ENDPOINT_URL,
  });
};
export default NhapKhoService;
